'use client';

import { Controller, useFormContext } from 'react-hook-form';
import AgentLocationPreferencePicker from '@/components/agent/profile/AgentLocationPreferencePicker';

type Props = {
  name: string;
  label?: string;
  placeholder?: string;
  helperText?: React.ReactNode;
  disabled?: boolean;
};

export function RHFAgentLocationPreferences({
  name,
  label,
  placeholder,
  helperText,
  disabled,
}: Props) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <AgentLocationPreferencePicker
          value={Array.isArray(field.value) ? field.value : []}
          onChange={field.onChange}
          label={label}
          placeholder={placeholder}
          helperText={error?.message || helperText}
          error={Boolean(error)}
          disabled={disabled}
        />
      )}
    />
  );
}
